import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { EstadosAgendamientoEnumChoice } from "../constants"
import { IAgendaCorporativo } from "../interfaces/erp/agenda_corporativo"


export const useTableColumnsAgendaCorporativa = (_estado: EstadosAgendamientoEnumChoice) => {


  const columnsAgendaCoporativo = useMemo<MRT_ColumnDef<IAgendaCorporativo>[]>(() => [
    {
      accessorKey: 'identificacion',
      header: 'identificacion',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.identificacion ?? 'N/A'}`
    },
    {
      accessorKey: 'razon_social',
      header: 'razon social',
      Cell: ({ row }) => `${row.original.prospecto_corporativo_data?.razon_social ?? 'N/A'}`
    },
    {
      accessorKey: 'nombre_personalizado',
      header: 'nombre enlace',
      Cell: ({ row }) => {
        const nombreBase = row.original?.preventa_corporativa_data?.data_plan_personalizado?.nombre_personalizado;
        if (!nombreBase) return "N/A";
        const esBackup = row.original?.factibilidad_corporativa_data?.es_backup;
        return esBackup ? `${nombreBase}_BACKUP` : nombreBase;
      }
    },
    {
      accessorKey: 'estado_agenda',
      enableColumnFilter:false,
      header: 'Estado agenda'
    },
    {
      accessorKey: 'fecha_instalacion',
      enableColumnFilter:false,
      header: 'Fecha instalacion'
    },
    {
      accessorKey: 'hora_instalacion',
      enableColumnFilter:false,
      header: 'Hora instalacion'
    },
    {
      accessorKey: 'flota',
      enableColumnFilter:false,
      header: 'Flota'
    },
    {
      accessorKey: 'preventa_corporativa',
      enableColumnFilter:false,
      header: 'Preventa corporativa'
    },

    {
      accessorKey: 'prospecto_corporativo',
      enableColumnFilter:false,
      header: 'Prospecto corporativo',
    },
    {
      accessorKey: 'user_create',
      enableColumnFilter:false,
      header: 'user create',
    },
    {
      accessorKey: 'fecha_creacion',
      enableColumnFilter:false,
      header: 'Fecha creacion',
    },
    {
      accessorKey: 'fecha_modificacion',
      enableColumnFilter:false,
      header: 'Fecha modificacion',
    },
  ], []);

  return {

    columnsAgendaCoporativo
  }
}